<template lang='pug'>
.mainWrapper-innerContent
  .mainWrapper-leftContent
    BreadCrumb(:breadcrumbList='breadcrumbs')
    PartnerProfile(:info="partnerInfo")
    TableBlock(
      type="latestArticlesByPartner"
      :params="params"
      :langInRoute='true'
      :displayList='true'
      :displayFilter='false'
      :displayLayoutOption='false'
      :displaySort='true'
      :noArticleText='noArticleText'
      :displayNoArticleOption='displayNoArticleOption'
      :staticData='data.topTenArticles'
      :sectionText="data.partnerInfo.title"
    )
  .mainWrapper-rightContent
    .sidebar--right
      OtherPartners(:infos="otherPartnerInfo")
</template>
<script>
import BreadCrumb from '@/components/modules/breadcrumb/breadcrumb.vue'
import PartnerProfile from '@/components/modules/partners/partner_profile.vue'
import TableBlock from '@/components/table/table_block.vue'
import OtherPartners from '@/components/modules/partners/other_partners.vue'
import { getRouteByParam } from '@/plugins/tool.js'

export default {
  props: {
    data: Object
  },
  components: {
    BreadCrumb,
    PartnerProfile,
    TableBlock,
    OtherPartners
  },
  data() {
    const urlQuery = this.$route.query
    let partnerId = urlQuery.id
    return {
      partnerId: partnerId,
      breadcrumbs: [
        {
          text: '首頁',
          link: '/'
        },
        {
          text: '合作夥伴',
          link: '/partners'
        }
      ],
      otherPartnerInfo: [],
      partnerInfo: {
        category: []
      },
      params: {
        "size": 10,
        "sort": {
          "updatedAt": {
            "dir": "desc",
            "default": true
          }
        },
        "page": 0,
        "partnerId": partnerId
      },
      noArticleText: "目前沒有資料。",
      displayNoArticleOption: false
    }
  },
  async created() {
    await this.getInfo()
    this.breadcrumbs.push({
      "text": this.partnerInfo.name,
      "link": this.$route.fullPath
    })
  },
  methods: {
    async getInfo() {
      let partnerId = this.$route.query.id
      let partnerStat = await this.getPartnerStats(partnerId)

      let route = this.$store.state.URLs.api + '/' + this.$store.state.lang + this.$store.state.routes.partners
      route = getRouteByParam(this.params, route)

      let result = await this.$axios.get(route)

      let allPartnerInfos = result.data.content;
      allPartnerInfos.forEach(info => {
        if (info.id == this.partnerId) {
          for (var key in partnerStat) {
            info[key] = partnerStat[key]
          }
          this.partnerInfo = info
        }
        else
          this.otherPartnerInfo.push(info)
      })
    },
    async getPartnerStats(partnerId) {
      let route = this.$store.state.URLs.api + '/' + this.$store.state.lang + this.$store.state.routes.partnersStats
      route += '?partnerId' + "=" + partnerId
      let result = await this.$axios.get(route)
      return result.data
    }
  }
}
</script>
